<template>
    <div class="phase_item_div">
        <div class="phase_title_div">
            <span class="line_span">
            </span>
            <span class="phase_item_title">
                {{ data.name }}
            </span>
            <span class="line_span">
            </span>
        </div>
        <div v-if="data.description" v-html="data.description"></div>
        <div class="phase_card_div">
            <CourseCard class="phase_course_card"
                        v-for="course in data.courses"
                        :key="course.id"
                        :data="course"
            >
            </CourseCard>
        </div>
        <DocumentDialog v-model="showDialog" type='download' :data=documentData :document_access="document_access"
                        @close="clickClose()"
                        @cancel="clickCancel()" @confirm="clickConfirm()"></DocumentDialog>
        <div v-if="data.docs.length>0" class="document_div">
            <h5 style="margin-left: 14px">资料：</h5>
            <div class="libary_main_libray_content_cards">
                <div class="libray_main_library_content_card" v-for="md in data.docs" :key="md.id">
                    <div @click="openDocumentDialog(md)">
                        <LibraryCard :data="md"></LibraryCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import documentApi from '@/api/document/document.js'
    import CourseCard from '@/components/common_components/cards/course_card.vue'
    import LibraryCard from '@/components/common_components/cards/library_card.vue'
    import DocumentDialog from '@/components/common_components/dialog/document_dialog.vue'

    export default {
        components: {
            DocumentDialog,
            CourseCard,
            LibraryCard
        },

        props: {
            data: {
                type: Object,
                require: true
            }
        },
        data() {
            return {
                showDialog: false,
                document_access: false,
                documentData: null
            }
        },
        methods: {
            openDocumentDialog(doc) {
                this.showDialog = true;
                this.documentData = doc;
                documentApi.get_document_access({'id': doc.id}).then((res) => {
                    this.document_access = res.data.document_access
                })
            },
            clickCancel() {
            },
            clickConfirm() {
            },
            clickClose() {
                this.showDialog = false;
            }
        }
    }
</script>
<style type="text/css" scoped>
    .libary_main_libray_content_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .libray_main_library_content_card {
        width: 33%;
        padding: 0 15px;
    }

    .phase_item_div {
        display: flex;
        flex-direction: column;
        margin-right: -15px;
        margin-left: -15px;
    }

    .phase_title_div {
        text-align: center;
        margin: 100px 0 50px;
        font-size: 20px;
        color: #787878;
    }

    .line_span {
        width: 15%;
        display: inline-block;
        border-top: 1px solid #ccc;
        margin-bottom: 5px;
    }

    .phase_card_div {
        display: flex;
        flex-wrap: wrap;

    }

    .phase_course_card {
        margin: 0 0 20px;
        padding: 0 15px;
        width: 33.33%;
    }

</style>
